import { SmokingSession } from '@store/api/sessionApi'

export interface OfflineSessionFilters {
  search?: string
  dateFrom?: string
  dateTo?: string
  sortBy?: 'smokedDate' | 'rating' | 'createdAt'
  sortOrder?: 'asc' | 'desc'
  page?: number
  limit?: number
}

export function filterOfflineSessions(sessions: SmokingSession[], filters: OfflineSessionFilters): SmokingSession[] {
  let result = [...sessions]

  if (filters.search?.trim()) {
    const q = filters.search.trim().toLowerCase()
    result = result.filter(
      (s) =>
        s.tastingNotes?.toLowerCase().includes(q) ||
        s.location?.toLowerCase().includes(q) ||
        s.cigar?.cigarLine?.brand?.name?.toLowerCase().includes(q) ||
        s.cigar?.cigarLine?.name?.toLowerCase().includes(q) ||
        s.cigar?.vitola?.name?.toLowerCase().includes(q),
    )
  }

  if (filters.dateFrom) {
    const start = new Date(filters.dateFrom).getTime()
    result = result.filter((s) => new Date(s.smokedDate).getTime() >= start)
  }
  if (filters.dateTo) {
    const end = new Date(filters.dateTo).getTime()
    result = result.filter((s) => new Date(s.smokedDate).getTime() <= end)
  }

  const sortBy = filters.sortBy ?? 'smokedDate'
  const sortOrder = filters.sortOrder ?? 'desc'

  result.sort((a, b) => {
    let av: string | number = ''
    let bv: string | number = ''
    if (sortBy === 'rating') {
      av = a.rating ?? 0
      bv = b.rating ?? 0
    } else if (sortBy === 'createdAt') {
      av = a.createdAt
      bv = b.createdAt
    } else {
      av = a.smokedDate
      bv = b.smokedDate
    }
    if (av < bv) return sortOrder === 'asc' ? -1 : 1
    if (av > bv) return sortOrder === 'asc' ? 1 : -1
    return 0
  })

  return result
}

export function paginateSessions(
  sessions: SmokingSession[],
  page = 1,
  limit = 12,
): { sessions: SmokingSession[]; total: number; totalPages: number } {
  const total = sessions.length
  const totalPages = Math.max(1, Math.ceil(total / limit))
  const safePage = Math.min(Math.max(1, page), totalPages)
  const start = (safePage - 1) * limit
  return {
    sessions: sessions.slice(start, start + limit),
    total,
    totalPages,
  }
}
